import React from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';
import { SalesPopup } from './components/SalesPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cream text-brand-900 font-sans selection:bg-brand-500 selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <Features data-id="element-3" />
      <Pricing data-id="element-4" />
      <SalesPopup data-id="element-5" />
    </div>;
}